{
  "internal_id": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "isNotRenderable": true
    }
  },
  "change_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Change Date",
      "width": 125,
      "isShownByDefault": true
    }
  },
  "expiry_date": {
    "source": "regulator",
    "domainType": "DateString",
    "ui": {
      "label": "Expiry Date",
      "width": 125,
      "isShownByDefault": true
    }
  },
  "province": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Province",
      "width": 80,
      "isShownByDefault": true
    }
  },
  "owners_json_array": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "label": "Owner",
      "width": 200,
      "isShownByDefault": true
    }
  },
  "zones_json_array": {
    "source": "regulator",
    "domainType": "object",
    "ui": {
      "isNotRenderable": true
    }
  },
  "status": {
    "source": "regulator",
    "domainType": "string",
    "ui": {
      "label": "Status",
      "width": 140,
      "isShownByDefault": true
    }
  },
  "area_ha": {
    "source": "regulator",
    "domainType": "SIUnit",
    "domainTypeAttributes": {
      "symbol": "ha"
    },
    "ui": {
      "label": "Area",
      "width": 80,
      "isShownByDefault": true
    }
  }
}
